import Apis from "@/apis"
import { useWindVane } from "@/features/useWindVane"
import AppSignals from "@/features_signal/app"
import { CustomError } from "@/utils/error"
import { createLogger } from "@/utils/logger"
import { toast } from "react-toastify"
const logger = createLogger("ApiFetchers")

interface UseDepositSubmitProps {
    onSuccess?: () => void
    onError?: (err: string) => void
}

export default ({ onSuccess, onError }: UseDepositSubmitProps = {}) => {
    const { tradePay } = useWindVane()
    const handleLaDeposit = async ({ exchangeCode }: { exchangeCode: string }) => {
        try {
            const res = await Apis.v1.refUpdateFinanceLazadaExchange({
                exchangeCode,
                device: "web",
            })
            logger.debug("refUpdateFinanceLazadaExchange", res)
            toast.success(res.data.data || "success")
            onSuccess?.()
        } catch (error) {
            logger.debug("refUpdateFinanceLazadaExchange error", error)
            const errorMessage = error instanceof CustomError ? error.message : String(error)
            onError?.(errorMessage || "deposit error")
            // toast.error(errorMessage || "deposit error")
        }
    }

    const handleWebDeposit = async (params: {
        amount: number
        pid: string
        channelName: string
    }) => {
        try {
            const response = await Apis.v1.refUpdateFinancePaymentDeposit({
                amount: params.amount.toString(),
                pid: params.pid,
                device: "web", //注意这里是写死的，不排除小程序会更换
            })
            logger.debug("refUpdateFinancePaymentDeposit", response.data)
            if (response.data.data) {
                onSuccess?.()
                const { pay_url } = response.data.data
                if (AppSignals.isMayaminiUser()) {
                    toast.success("deposit success")
                } else if (AppSignals.isLazadaminiUser()) {
                    if (pay_url) {
                        try {
                            await tradePay(pay_url)
                            console.log("lazada-mini deposit success")
                        } catch (e) {
                            console.error("lazada-mini deposit error", e)
                            toast.error("lazada-mini deposit error")
                        }
                    } else {
                        toast.error("lazada-mini deposit error")
                    }
                } else {
                    if (pay_url) {
                        window.location.href = pay_url
                    } else {
                        throw new Error("deposit pay_url error")
                    }
                }
            } else {
                toast(response.data as string)
                throw new Error("Recharge failed")
            }
        } catch (error) {
            logger.debug("refUpdateFinancePaymentDeposit error", error)
            const errorMessage = error instanceof CustomError ? error.message : String(error)
            // toast.error(errorMessage || "deposit error")
            onError?.(errorMessage || "deposit error")
        }
    }

    return {
        handleWebDeposit,
        handleLaDeposit,
    }
}
